var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "resize_iframe" } },
    [
      _vm.isShowEntryPage()
        ? _c("EntryPage", {
            attrs: {
              getDatetimeString: _vm.getDatetimeString,
              formatNumberByStep: _vm.formatNumberByStep,
              commonSetting: _vm.commonSetting,
              groupName: _vm.groupName,
              encryptJobCode: _vm.encryptJobCode,
              hash: _vm.log.hash,
              resourcesAPI: _vm.resourcesAPI,
              TYPE_OF_SINGLE_SELECT: _vm.TYPE_OF_SINGLE_SELECT,
              TYPE_OF_MULTI_SELECT: _vm.TYPE_OF_MULTI_SELECT,
              FORMAT_DATE: _vm.FORMAT_DATE,
              TYPE_OF_NUMBER: _vm.TYPE_OF_NUMBER,
              isDisplayPrint: _vm.isDisplayPrint
            },
            on: {
              createLogger: function($event) {
                return _vm.createLogger($event)
              },
              syncCheckDisplayPrint: function($event) {
                return _vm.checkAllowDisplay($event)
              },
              printPage: _vm.printPage
            }
          })
        : _vm._e(),
      _vm.isShowJobSearchPage()
        ? _c("SearchJobPage", {
            attrs: {
              getDatetimeString: _vm.getDatetimeString,
              formatNumberByStep: _vm.formatNumberByStep,
              isPreviousItemHaveData: _vm.isPreviousItemHaveData,
              isObjectDataHasValue: _vm.isObjectDataHasValue,
              encryptJobCode: _vm.encryptJobCode,
              groupName: _vm.groupName,
              commonSetting: _vm.commonSetting,
              hash: _vm.log.hash,
              resourcesAPI: _vm.resourcesAPI,
              TYPE_OF_SINGLE_SELECT: _vm.TYPE_OF_SINGLE_SELECT,
              TYPE_OF_MULTI_SELECT: _vm.TYPE_OF_MULTI_SELECT,
              FORMAT_DATE: _vm.FORMAT_DATE,
              TYPE_OF_NUMBER: _vm.TYPE_OF_NUMBER,
              isDisplayPrint: _vm.isDisplayPrint
            },
            on: {
              createLogger: function($event) {
                return _vm.createLogger($event)
              },
              syncCheckDisplayPrint: function($event) {
                return _vm.checkAllowDisplay($event)
              },
              printPage: _vm.printPage
            }
          })
        : _vm._e(),
      _vm.isShowJobDetail()
        ? _c("DetailJobPage", {
            attrs: {
              getDatetimeString: _vm.getDatetimeString,
              formatNumberByStep: _vm.formatNumberByStep,
              isPreviousItemHaveData: _vm.isPreviousItemHaveData,
              isObjectDataHasValue: _vm.isObjectDataHasValue,
              encryptJobCode: _vm.encryptJobCode,
              encryptEntryCode: _vm.encryptEntryCode,
              groupName: _vm.groupName,
              commonSetting: _vm.commonSetting,
              hash: _vm.log.hash,
              TYPE_OF_SINGLE_SELECT: _vm.TYPE_OF_SINGLE_SELECT,
              TYPE_OF_MULTI_SELECT: _vm.TYPE_OF_MULTI_SELECT,
              FORMAT_DATE: _vm.FORMAT_DATE,
              TYPE_OF_NUMBER: _vm.TYPE_OF_NUMBER,
              isDisplayPrint: _vm.isDisplayPrint
            },
            on: {
              createLogger: function($event) {
                return _vm.createLogger($event)
              },
              syncCheckDisplayPrint: function($event) {
                return _vm.checkAllowDisplay($event)
              },
              printPage: _vm.printPage
            }
          })
        : _vm._e(),
      _vm.isShowDetailDispatchJobPage()
        ? _c("DetailDispatchJobPage", {
            attrs: {
              getDatetimeString: _vm.getDatetimeString,
              formatNumberByStep: _vm.formatNumberByStep,
              isPreviousItemHaveData: _vm.isPreviousItemHaveData,
              isObjectDataHasValue: _vm.isObjectDataHasValue,
              encryptJobCode: _vm.encryptJobCode,
              encryptEntryCode: _vm.encryptEntryCode,
              groupName: _vm.groupName,
              commonSetting: _vm.commonSetting,
              hash: _vm.log.hash,
              resourcesAPI: _vm.resourcesAPI,
              TYPE_OF_SINGLE_SELECT: _vm.TYPE_OF_SINGLE_SELECT,
              TYPE_OF_MULTI_SELECT: _vm.TYPE_OF_MULTI_SELECT,
              FORMAT_DATE: _vm.FORMAT_DATE,
              TYPE_OF_NUMBER: _vm.TYPE_OF_NUMBER,
              isDisplayPrint: _vm.isDisplayPrint
            },
            on: {
              createLogger: function($event) {
                return _vm.createLogger($event)
              },
              syncCheckDisplayPrint: function($event) {
                return _vm.checkAllowDisplay($event)
              },
              printPage: _vm.printPage
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }